import { IOptionAnyValue } from 'bricks/types';
import {
    STRUCTURED_PARKING, SURFACE_PARKING, TRAILER_PARKING, UNDERGROUND_PARKING,
} from 'views/ProFormaTable/constants';
import { BasicInformationValues } from './types';
import {
    BASIC_INFORMATION, DEVELOPMENT, OPERATIONS,
} from './constants';

export const updateParkingAndSpaces = (formData: BasicInformationValues, parkingOptions: IOptionAnyValue[] | null) => {
    let updatedFormData = { ...formData };
    if (parkingOptions == null || parkingOptions.length === 0) {
        updatedFormData = {
            ...updatedFormData,
            parking: [],
            structuredParkingSpaces: null,
            surfaceParkingSpaces: null,
            undergroundParkingSpaces: null,
            trailerParkingSpaces: null,
        };
        return updatedFormData;
    }
    const newParkingValues = (parkingOptions || []).map((p: IOptionAnyValue) => p.value);
    updatedFormData = {
        ...updatedFormData,
        parking: parkingOptions,
        structuredParkingSpaces: newParkingValues.includes(STRUCTURED_PARKING) ? updatedFormData.structuredParkingSpaces : null,
        surfaceParkingSpaces: newParkingValues.includes(SURFACE_PARKING) ? updatedFormData.surfaceParkingSpaces : null,
        undergroundParkingSpaces: newParkingValues.includes(UNDERGROUND_PARKING) ? updatedFormData.undergroundParkingSpaces : null,
        trailerParkingSpaces: newParkingValues.includes(TRAILER_PARKING) ? updatedFormData.trailerParkingSpaces : null,
    };

    return updatedFormData;
};

export const getTenantDateRange = (
    proFormaStartDate: Date | null, constructionStart: Date | null,
    constructionDuration: number | null, holdPeriod: number | null,
) => {
    let operationStartDate: Date | undefined;
    let proFormaSaleDate: Date | undefined;

    if (constructionStart && constructionDuration) {
        const operationStart = new Date(constructionStart);
        operationStart.setMonth(operationStart.getMonth() + (constructionDuration + 1));
        operationStartDate = operationStart;
    }

    if (proFormaStartDate && holdPeriod) {
        const saleDate = new Date(proFormaStartDate);
        saleDate.setMonth(saleDate.getMonth() + holdPeriod);

        if (operationStartDate) {
            // Calculate operationStartDate + 1 month
            const minSaleDate = new Date(operationStartDate);
            minSaleDate.setMonth(minSaleDate.getMonth() + 1);

            // If proForma sale is earlier, override it
            // sale date should be later than operation start date
            proFormaSaleDate = saleDate < minSaleDate ? minSaleDate : saleDate;
        } else {
            proFormaSaleDate = saleDate;
        }
    }

    return { operationStartDate, proFormaSaleDate };
};

export const getHeapClassName = (navName: string) => {
    const heapClassNames: Record<string, string> = {
        [BASIC_INFORMATION]: 'heap-deal-signup-step-2-basic-info-tab',
        [DEVELOPMENT]: 'heap-deal-signup-step-2-development-tab',
        [OPERATIONS]: 'heap-deal-signup-step-2-operations-tab',
    };
    return heapClassNames[navName] || '';
};
